var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "club_info" } },
    [
      _vm._t("activator", null, {
        on: { click: () => (_setup._isOpened = true) },
      }),
      _vm._v(" "),
      _c(
        _setup.CoreDrawer,
        {
          attrs: { title: "Клуб ПроДокторов", width: 650 },
          scopedSlots: _vm._u([
            {
              key: "title-append",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "ml-1",
                    attrs: {
                      src: "/static/_v1/pd/icons/ui-kit/club/club-percent.svg",
                      width: "24",
                      height: "24",
                      alt: "Иконка Процент Клуба",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.isOpened,
            callback: function ($$v) {
              _setup.isOpened = $$v
            },
            expression: "isOpened",
          },
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-column gr-8 px-4 py-2" }, [
            _c("div", { staticClass: "d-flex flex-column gr-2" }, [
              _c("div", { staticClass: "text-h6 text--text" }, [
                _vm._v("\n          Что такое клубная цена\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-body-1 text--text" }, [
                _vm._v(
                  "\n          Возможность получить скидку 30% на консультацию врача, купив невозвратный опцион.\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-column gr-2" }, [
              _c("div", { staticClass: "text-h6 text--text" }, [
                _vm._v("\n          Как получить клубную скидку\n        "),
              ]),
              _vm._v(" "),
              _c("ol", { staticClass: "club-info-list text-body-1" }, [
                _c("li", [
                  _vm._v(
                    "При записи к врачу приобретаете опцион на сайте ПроДокторов"
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("Получаете опцион на email или в приложение МедТочка"),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "В день приёма показываете в клинике опцион и оплачиваете консультацию по цене со скидкой"
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-column gr-6" },
              [
                _c("div", { staticClass: "text-h6 text--text" }, [
                  _vm._v("\n          Вопросы и ответы\n        "),
                ]),
                _vm._v(" "),
                _c(_setup.ClubFaqList),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex flex-column gr-2" }, [
              _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
                _vm._v(
                  "\n          © 2011 — " +
                    _vm._s(_setup.nowYear) +
                    ", ООО «МЕДРОКЕТ»\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-block text-body-2 text-secondary--text mt-2",
                },
                [
                  _vm._v(
                    "\n          Оплачивая, вы соглашаетесь\n          с "
                  ),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-secondary--text link-decoration-underline",
                      attrs: {
                        "data-qa": "club_info_offer_link",
                        href: "/static/_v1/pd/documents/pdf/club/Правила_использования_опционов.pdf",
                        rel: "noopener noreferrer",
                        target: "_blank",
                      },
                    },
                    [_vm._v("офертой")]
                  ),
                  _vm._v("\n          и "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-secondary--text link-decoration-underline",
                      attrs: {
                        "data-qa": "club_info_club_rules_link",
                        href: "/static/_v1/pd/documents/pdf/club/Правила_участия_в_клубе.pdf",
                        rel: "noopener noreferrer",
                        target: "_blank",
                      },
                    },
                    [_vm._v("правилами клуба")]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }